// @flow

type Action =
  | { type: 'SCRIBE_DASHBOARD_WS_URL', scribeUrl: string }
  | {
      type: 'SCRIBE_DASHBOARD_ROOMS_UPDATE',
      subtype: string,
      room: any,
    };

export type State = {
  rooms: Array<any>,
  scribeUrl?: string,
};

const initialState: State = { rooms: [] };

export default function scribeDashboard(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'SCRIBE_DASHBOARD_WS_URL': {
      return {
        ...state,
        scribeUrl: action.scribeUrl,
      };
    }

    case 'SCRIBE_DASHBOARD_ROOMS_UPDATE': {
      switch (action.subtype) {
        case 'add-room':
          if (action.room && action.room.id) {
            return {
              ...state,
              rooms: [
                // $FlowFixMe
                ...state.rooms.filter(r => r.id !== action.room.id),
                action.room,
              ],
            };
          }
          break;
        case 'room-status-update':
          if (action.room) {
            return {
              ...state,
              rooms: [
                // $FlowFixMe
                ...state.rooms.filter(r => r.id !== action.room.id),
                action.room,
              ],
            };
          }
          break;
        case 'remove-room':
          return {
            ...state,
            // $FlowFixMe
            rooms: state.rooms.filter(r => r.id !== action.room.id),
          };
        default:
          break;
      }
      return state;
    }

    default:
      // eslint-disable-next-line no-unused-expressions
      (action: empty);
      return state;
  }
}
